export default "__VITE_ASSET__DTjRBpU2__"